import { useErrorHandlingSlice } from 'app/error/slice';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import useApi from 'services/mavapi/useApi';
import {
  GeneralLookupWrapper,
  LookupService,
  ReportService,
  TeamDetailsResponse,
  TeamPointWrapper,
  TeamRankingResponse,
} from 'services/openapi';

const useTeamReportsApi = () => {
  const { actions } = useErrorHandlingSlice();
  const dispatch = useDispatch();
  const [, setError] = useState<unknown | null>();
  const { error: apiError, handleRequest } = useApi();
  const [loading, setLoading] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const { reportGetTeamPointsDetails, reportGetTeamPointReport, reportGetTeamRankingReport, reportGetTeamRankingDetails, reportGetTeamDetails } =
    ReportService;

  // States
  const [showInfoData, setShowInfoData] = useState<TeamPointWrapper>();
  const [teamRankingData, setTeamRankingData] = useState<TeamRankingResponse>();
  const [teamInnerViewData, setTeamInnerViewData] = useState<TeamDetailsResponse>();

  const getTeamPointsDetails = (seasonId: string) => {
    setLoading(true);
    handleRequest(reportGetTeamPointsDetails(seasonId))
      .then(res => {
        setShowInfoData(res);
        setLoading(false);
      })
      .catch(() => {
        setError(apiError);
        setLoading(false);
      });
  };
  const downloadTeamPoints = (seasonId: string): Promise<string> => {
    setLoading(true);
    return new Promise((resolve, reject) => {
      handleRequest(reportGetTeamPointReport(seasonId))
        .then(res => {
          resolve(res);
          setLoading(false);
        })
        .catch(() => {
          reject(apiError);
          setLoading(false);
        });
    });
  };
  const getTeamRankingDetails = (seasonId?: string) => {
    setLoading(true);
    handleRequest(reportGetTeamRankingDetails(seasonId))
      .then(res => {
        setTeamRankingData(res);
        setLoading(false);
      })
      .catch(() => {
        setError(apiError);
        setLoading(false);
      });
  };
  const getTeamRankingInnerViewDetails = (teamId: string) => {
    setLoading(true);
    handleRequest(reportGetTeamDetails(teamId))
      .then(res => {
        setTeamInnerViewData(res);
        setLoading(false);
      })
      .catch(() => {
        setError(apiError);
        setLoading(false);
      });
  };
  const downloadTeamRankingReport = (seasonId?: string): Promise<string> => {
    setIsDownloading(true);
    return new Promise((resolve, reject) => {
      handleRequest(reportGetTeamRankingReport(seasonId))
        .then((res) => {
          dispatch(
            actions.dispatchToast({
              errorTxt: 'Team Ranking Downloaded Successfully',
              show: true,
              errorType: 'success',
            }),
          );
          resolve(res);
          setIsDownloading(false);
        })
        .catch(() => {
          reject(apiError);
          setIsDownloading(false);
        });
    });
  };
  return {
    loading,
    getTeamPointsDetails,
    showInfoData,
    downloadTeamPoints,
    teamRankingData,
    downloadTeamRankingReport,
    getTeamRankingDetails,
    isDownloading,
    getTeamRankingInnerViewDetails,
    teamInnerViewData
  };
};

export default useTeamReportsApi;
